import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // must be authenticated
    if (!this.authService.isLoggedIn()) {
      this.authService.startAuthentication(state.url);
      return false;
    }

    if (route?.data?.users?.length && route?.data?.users.indexOf(this.authService.getUserName()) > -1) {
      return true;
    }

    if (this.authService.hasFullAccess()) {
      return true;
    }

    let authorized = true;
    if (route?.data?.roles?.length > 0 && !this.authService.isAuthorized(route.data.roles)) {
      authorized = false;
    }

    if (authorized) {
      return true;
    }

    // unauthorized
    return this.router.parseUrl('/unauthorized');
  }
}
